import { Component, inject, Input, OnDestroy, OnInit, signal } from '@angular/core';
import { Record } from '../../../../models/record';
import { BaseDropdownOptionsButtonComponent } from '../../../base-dropdown-options-button/base-dropdown-options-button.component';
import { filter, Subscription, take, tap } from 'rxjs';
import { UserFacade } from 'src/app/_core/state/user/user.facade';

@Component({
  selector: 'app-swiper-more-button',
  templateUrl: './swiper-more-button.component.html',
  styleUrls: ['./swiper-more-button.component.scss'],
})
export class SwiperMoreButtonComponent extends BaseDropdownOptionsButtonComponent implements OnInit, OnDestroy {
  private readonly userFacade = inject(UserFacade);

  @Input() record: Record;

  readonly canRenewCheckouts = signal<boolean>(false);

  private favoriteAddedSubscription: Subscription;
  private favoriteRemovedSubscription: Subscription;

  ngOnInit(): void {
    super.record = this.record;
    this.checkout.set(this.checkoutsFacade.getCheckoutByRecordId(this.record.id, this.issueDate, this.rhId));
    this.canRenewCheckouts.set(this.config && this.config.renew && this.configService.get().renewCheckouts);
    this.showReturnLoanButton = this.configService.get().showReturnLoanButton;
    this.isCheckedOut = this.checkIsCheckedOut();

    this.alreadyInFavorites = this.favoriteFacade.getFavoriteByRecordId(this.record.id) !== undefined;

    this.favoriteFacade.favoriteAdded$.subscribe((favoriteAdded) => {
      if (favoriteAdded?.recordId === this.record.id) {
        this.alreadyInFavorites = true;
        this.favoriteIcon = 'favorite_black';
        this.favoriteText = 'tooltip.removeFromFavorites';
      }
    });

    this.favoriteFacade.favoriteRemoved$.subscribe((favoriteRemoved) => {
      if (favoriteRemoved?.recordId === this.record.id) {
        this.alreadyInFavorites = false;
        this.favoriteIcon = 'favorite';
        this.favoriteText = 'tooltip.addToFavorites';
      }
    });

    this.alreadyInFavorites = this.favoriteFacade.getFavoriteByRecordId(this.record.id) !== undefined;
    this.favoriteIcon = this.alreadyInFavorites ? 'favorite_black' : 'favorite';
    this.favoriteText = this.alreadyInFavorites ? 'tooltip.removeFromFavorites' : 'tooltip.addToFavorites';

    this.showShareButtons = this.configService.get().showSocialIcons;
    this.socialButtons = this.configService.shareIcons;
    this.shareText = this.localeService.getLocalizedShareText(this.record, this.configService.get().title);
    this.showReportIssueButton =
      this.userFacade.user && this.configService.get().showReportIssueButton === undefined
        ? true
        : this.configService.get().showReportIssueButton;
  }

  ngOnDestroy(): void {
    this.favoriteAddedSubscription?.unsubscribe();
    this.favoriteRemovedSubscription?.unsubscribe();
  }

  showConfirmationDialog() {
    this.confirmationDialogFacade.openDialog('general.return.checkout', 'messages.checkout.confirmRemove');
    this.confirmationDialogFacade.closeResult$
      .pipe(
        filter((closeResult) => typeof closeResult === 'boolean'),
        take(1)
      )
      .subscribe((result) => {
        if (result) {
          this.doReturn();
        }

        this.confirmationDialogFacade.closeDialog();
      });
  }
}
